module.exports = __webpack_public_path__ + "images/backgrounds/river/small.15967f866d002762d13d.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/river/small.jpg
// module id = bGNr
// module chunks = 13